import { type } from "seneca-common/utils/routing/react-router-typesafe-routes/dom";

export function noValidationType<T>() {
  return type<T>(v => v as T);
}
